module.exports = __webpack_public_path__ + "img/03.189d081d.png";